export const GOOGLE_CLIENT_ID =
  "109174840570-qqkl50bvekkb2v8cvn4ls8onsnpf6nts.apps.googleusercontent.com";
